import script from "./ImageStylePanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImageStylePanel.vue?vue&type=script&lang=ts&setup=true"

import "./ImageStylePanel.vue?vue&type=style&index=0&id=080b6de7&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-080b6de7"]])

export default __exports__